import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import * as PropTypes from 'prop-types';
import { Spin, Progress } from 'antd';
import { loadFPAvg } from '../../redux/actions/widgets';
import styles from './fp-avg.module.sass';
import { STATUS } from '../../redux/constants';

export const FalsePositiveAverage = (props) => {
  const { fpAvg, status } = props;
  useEffect(() => {
    props.loadFPAvg();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const isLoading = status === STATUS.LOADING;

  return (
    <div className={styles.container}>
      {isLoading && <Spin />}
      {!isLoading && (
        <div className={styles.body}>
          <span className={styles.value}>{fpAvg}</span>
          <Progress
            className={styles.progressbar}
            percent={fpAvg}
            showInfo={false}
            strokeWidth={16}
            strokeColor="#8FD460"
          />
        </div>
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  fpAvg: state.widgets.fpAvg,
  status: state.widgets.fpAvgStatus,
});

const mapDispatchToProps = {
  loadFPAvg,
};

FalsePositiveAverage.propTypes = {
  loadFPAvg: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  fpAvg: PropTypes.number.isRequired,
};

FalsePositiveAverage.defaultProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FalsePositiveAverage);
